import type { Benefit, Review } from '@/@types/bankroll';
import { i18n } from '@/lang';

export const onboardingBenefits: Benefit[] = [
  {
    image: require('@/assets/p1.png'),
    title: i18n.global.t('text_onboarding_benefits_0_title'),
    text: i18n.global.t('text_onboarding_benefits_0_text'),
  },
  {
    image: require('@/assets/p2.png'),
    title: i18n.global.t('text_onboarding_benefits_1_title'),
    text: i18n.global.t('text_onboarding_benefits_1_text'),
  },
  {
    image: require('@/assets/p3.png'),
    title: i18n.global.t('text_onboarding_benefits_2_title'),
    text: i18n.global.t('text_onboarding_benefits_2_text'),
  },
];
export const membershipBenefits: Benefit[] = [
  {
    image: require('@/assets/p1.png'),
    title: i18n.global.t('text_membership_benefits_0_title'),
    text: i18n.global.t('text_membership_benefits_0_text'),
  },
  {
    image: require('@/assets/p2.png'),
    title: i18n.global.t('text_membership_benefits_1_title'),
    text: i18n.global.t('text_membership_benefits_1_text'),
  },
  {
    image: require('@/assets/p3.png'),
    title: i18n.global.t('text_membership_benefits_2_title'),
    text: i18n.global.t('text_membership_benefits_2_text'),
  },
];

export const offerBenefits: Benefit[] = [
  {
    image: require('@/assets/lto_image-1.png'),
    title: i18n.global.t('text_offer_benefits_0_title'),
    text: i18n.global.t('text_offer_benefits_0_text'),
  },
  {
    image: require('@/assets/lto_image-2.png'),
    title: i18n.global.t('text_offer_benefits_1_title'),
    text: i18n.global.t('text_offer_benefits_1_text'),
  },
  {
    image: require('@/assets/lto_image-3.png'),
    title: i18n.global.t('text_offer_benefits_2_title'),
    text: i18n.global.t('text_offer_benefits_2_text'),
  },
];

export const customerReviews: Review[] = [
  {
    author: i18n.global.t('text_customer_reviews_0_author'),
    date: i18n.global.t('text_customer_reviews_0_date'),
    title: i18n.global.t('text_customer_reviews_0_title'),
    text: i18n.global.t('text_customer_reviews_0_text'),
    avatar: require(`@/assets/user_photo_1.svg`),
  },
  {
    author: i18n.global.t('text_customer_reviews_1_author'),
    date: i18n.global.t('text_customer_reviews_1_date'),
    title: i18n.global.t('text_customer_reviews_1_title'),
    text: i18n.global.t('text_customer_reviews_1_text'),
    avatar: require(`@/assets/user_photo_2.svg`),
  },
  {
    author: i18n.global.t('text_customer_reviews_2_author'),
    date: i18n.global.t('text_customer_reviews_2_date'),
    title: i18n.global.t('text_customer_reviews_2_title'),
    text: i18n.global.t('text_customer_reviews_2_text'),
    avatar: require(`@/assets/user_photo_3.svg`),
  },
];
